import React from 'react'
import { Box } from '@mui/material'
import { Dialog } from '@center/ui-kit'

import { useUser } from 'store'

const ModalPicture = ({ onClose, children }) => {
  const [user] = useUser()
  return (
    <Dialog className="pictures" style={{ backgroundColor: '#282828E0' }} open>
      <Box position={'absolute'} sx={{ zIndex: 1 }} right={0}>
        <Box
          onClick={onClose}
          backgroundColor={'black'}
          sx={{
            opacity: 0.8,
            cursor: 'pointer',
            padding: '2px 8px',
            borderBottomLeftRadius: 4
          }}>
          <i className={'fa-regular fa-xmark'} style={{ color: 'white' }} />
        </Box>
      </Box>
      <div style={{width: '100%', ...(user.demo_mode && { filter: 'blur(16px)' })}}>
        {children}
      </div>
      
    </Dialog>
  )
}

export default ModalPicture
